function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define("YWWriterIconsReact.ChevronUp", ["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.React);
    global.YWWriterIconsReact = global.YWWriterIconsReact || {};
    global.YWWriterIconsReact["ChevronUp"] = mod.exports.default;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (exports, React) {
  "use strict";

  var ChevronUp = props => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.58569L2.31264 15.2731C1.92211 15.6636 1.92211 16.2967 2.31264 16.6873C2.70316 17.0778 3.33633 17.0778 3.72685 16.6873L12 8.41412L20.2731 16.6873C20.6637 17.0778 21.2968 17.0778 21.6874 16.6873C22.0779 16.2967 22.0779 15.6636 21.6874 15.2731L12 5.58569Z",
    fill: "currentColor"
  }));
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = ChevronUp;
});